(function () {
  "use strict";

  var PAGE_SELECTOR = "[data-kll-sep-page]";
  var REDUCED_MOTION = "(prefers-reduced-motion: reduce)";

  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia(REDUCED_MOTION).matches;
  }

  function announce(page, message) {
    var live = page.querySelector("[data-kll-sep-live]");
    if (!live) return;

    live.textContent = message;
    live.classList.add("is-visible");

    window.clearTimeout(live._kllSepTimer);
    live._kllSepTimer = window.setTimeout(function () {
      live.classList.remove("is-visible");
    }, 2200);
  }

  function setupSmoothAnchors(page) {
    page.addEventListener("click", function (event) {
      var link = event.target.closest('a[href^="#"]');
      if (!link || !page.contains(link)) return;

      var selector = link.getAttribute("href");
      var target = selector ? document.querySelector(selector) : null;
      if (!target) return;

      event.preventDefault();
      target.scrollIntoView({
        behavior: prefersReducedMotion() ? "auto" : "smooth",
        block: "start"
      });
    });
  }

  function setupReveal(page) {
    var items = Array.prototype.slice.call(page.querySelectorAll("[data-kll-reveal]"));
    if (!items.length) return;

    if (prefersReducedMotion() || !("IntersectionObserver" in window)) {
      items.forEach(function (item) {
        item.classList.add("is-visible");
      });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add("is-visible");
        observer.unobserve(entry.target);
      });
    }, {
      threshold: 0.12,
      rootMargin: "0px 0px -8% 0px"
    });

    items.forEach(function (item) {
      observer.observe(item);
    });
  }

  function updateCarouselState(carousel) {
    var track = carousel.querySelector("[data-kll-sep-track]");
    var previous = carousel.querySelector("[data-kll-sep-prev]");
    var next = carousel.querySelector("[data-kll-sep-next]");
    if (!track || !previous || !next) return;

    var maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
    previous.disabled = track.scrollLeft <= 3;
    next.disabled = track.scrollLeft >= maxScroll - 3 || maxScroll <= 3;
  }

  function setupCarousels(page) {
    page.querySelectorAll("[data-kll-sep-carousel]").forEach(function (carousel) {
      var track = carousel.querySelector("[data-kll-sep-track]");
      var previous = carousel.querySelector("[data-kll-sep-prev]");
      var next = carousel.querySelector("[data-kll-sep-next]");
      if (!track || !previous || !next) return;

      function move(direction) {
        var amount = Math.max(260, track.clientWidth * 0.82) * direction;
        track.scrollBy({
          left: amount,
          behavior: prefersReducedMotion() ? "auto" : "smooth"
        });
      }

      previous.addEventListener("click", function () {
        move(-1);
      });

      next.addEventListener("click", function () {
        move(1);
      });

      track.addEventListener("keydown", function (event) {
        if (event.key !== "ArrowLeft" && event.key !== "ArrowRight") return;
        event.preventDefault();
        move(event.key === "ArrowRight" ? 1 : -1);
      });

      var scheduled = false;
      track.addEventListener("scroll", function () {
        if (scheduled) return;
        scheduled = true;
        window.requestAnimationFrame(function () {
          updateCarouselState(carousel);
          scheduled = false;
        });
      }, { passive: true });

      updateCarouselState(carousel);
      window.addEventListener("resize", function () {
        updateCarouselState(carousel);
      }, { passive: true });
    });
  }

  function dispatchCartEvents(cart) {
    ["cart:refresh", "cart:change", "cart:updated", "cart:added"].forEach(function (name) {
      document.dispatchEvent(new CustomEvent(name, {
        bubbles: true,
        detail: { cart: cart, source: "kll-september-campaign" }
      }));
    });
  }

  function addVariant(variantId) {
    return window.fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      body: JSON.stringify({
        id: Number(variantId),
        quantity: 1
      })
    }).then(function (response) {
      if (!response.ok) throw new Error("Unable to add this item");
      return response.json();
    }).then(function (item) {
      return window.fetch("/cart.js", {
        headers: { "Accept": "application/json" }
      }).then(function (response) {
        if (!response.ok) return { addedItem: item };
        return response.json();
      });
    });
  }

  function setupQuickAdd(page) {
    page.addEventListener("click", function (event) {
      var button = event.target.closest("[data-kll-sep-add]");
      if (!button || !page.contains(button) || button.disabled) return;

      var variantId = button.getAttribute("data-variant-id");
      var originalLabel = button.getAttribute("data-original-label") || button.textContent || "Add";
      if (!variantId) {
        announce(page, "Choose a product option on the product page.");
        return;
      }

      button.disabled = true;
      button.textContent = "Adding";
      button.setAttribute("aria-busy", "true");

      addVariant(variantId).then(function (cart) {
        button.classList.add("is-added");
        button.textContent = "Added";
        announce(page, "Added to cart.");
        dispatchCartEvents(cart);

        window.setTimeout(function () {
          button.classList.remove("is-added");
          button.textContent = originalLabel;
          button.disabled = false;
          button.removeAttribute("aria-busy");
        }, 1400);
      }).catch(function () {
        button.textContent = "Try again";
        announce(page, "The item could not be added. Please try again.");

        window.setTimeout(function () {
          button.textContent = originalLabel;
          button.disabled = false;
          button.removeAttribute("aria-busy");
        }, 1800);
      });
    });
  }

  function setupHeroMotion(page) {
    var hero = page.querySelector("[data-kll-sep-hero]");
    var media = hero ? hero.querySelector(".kll-sep-hero__media") : null;
    if (!hero || !media || prefersReducedMotion() || window.matchMedia("(max-width: 749px)").matches) return;

    var frame = null;
    hero.addEventListener("pointermove", function (event) {
      if (frame) return;
      frame = window.requestAnimationFrame(function () {
        var rect = hero.getBoundingClientRect();
        var x = (event.clientX - rect.left) / rect.width - 0.5;
        var y = (event.clientY - rect.top) / rect.height - 0.5;
        media.style.transform = "scale(1.035) translate3d(" + (x * -10).toFixed(2) + "px," + (y * -6).toFixed(2) + "px,0)";
        frame = null;
      });
    }, { passive: true });

    hero.addEventListener("pointerleave", function () {
      media.style.transform = "scale(1.025) translate3d(0,0,0)";
    });
  }

  function initPage(page) {
    if (!page || page.getAttribute("data-kll-sep-ready") === "true") return;
    page.setAttribute("data-kll-sep-ready", "true");
    page.classList.add("is-js");

    setupSmoothAnchors(page);
    setupCarousels(page);
    setupQuickAdd(page);
    setupHeroMotion(page);
    setupReveal(page);
  }

  function initAll(root) {
    var scope = root || document;
    if (scope.matches && scope.matches(PAGE_SELECTOR)) initPage(scope);
    scope.querySelectorAll(PAGE_SELECTOR).forEach(initPage);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener("shopify:section:load", function (event) {
    initAll(event.target);
  });
})();
